import * as React from "react";
import NavigationBar from "./Components/NavigationBar/NavigationBar";
import Jumbotron from "./Sections/Jumbotron/Jumbotron";
import About from "./Sections/About/About";
import Experience from "./Sections/Experience/Experience";
import Academics from "./Sections/Academics/Academics";
import Abilities from "./Sections/Abilities/Abilities";
import Contact from "./Sections/Contact/Contact";

class App extends React.Component {
  render() {
    return (
      <div className="site-wrapper">
        <NavigationBar />
        <Jumbotron />
        <About />
        <Experience />
        <Academics />
        <Abilities />
        <Contact />
      </div>
    );
  }
}

export default App;
